var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainContainer',{style:({ 'padding-bottom': '80px' }),attrs:{"container":!_vm.xs(),"background":"darkGrey","footer":false}},[_vm._t("default"),_c('ActionBar',{style:({ 'height': '80px' }),attrs:{"fixed":true}},[_vm._t("actionBar")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }